import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import * as _ from 'lodash';
import { CompanyMasterService } from '../../../services/companymaster.service';
import { DashboardMyTaskService } from '../../../services/dashboardmytask.service';
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import { environment } from '../../../../environments/environment';
import { MeetingdetailsComponent } from '../meetingdetails/meetingdetails.component';
import { RegularMeetingModalComponent } from '../regular-meeting-modal/regular-meeting-modal.component';

@Component({
  selector: 'app-dashboard-meetings-list',
  templateUrl: './dashboard-meetings-list.component.html',
  styleUrls: ['./dashboard-meetings-list.component.css'],
})
export class DashboardMeetingsListComponent implements OnInit, OnChanges {
  @Input() refreshData: any;

  searchText = '';
  displayedMeetings: any[] = [];
  meetingListCache: any[] = [];
  regularAndComplianceMeetingList: any[] = [];
  isLoading = true;
  isEmpty = false;
  todayDate: number;

  private isMeetingsFetch: string;

  constructor(
    private companyMasterService: CompanyMasterService,
    private meetingMasterService: MeetingMasterService,
    private dashboardMyTaskService: DashboardMyTaskService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.todayDate = new Date().setHours(0, 0, 0, 0);
    this.isMeetingsFetch = localStorage.getItem('isMeetingsFetch');
    if (this.isMeetingsFetch !== 'false') {
      this.loadMeetings();
    } else {
      this.isLoading = false;
      this.isEmpty = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.refreshData &&
      !changes.refreshData.firstChange &&
      this.isMeetingsFetch !== 'false'
    ) {
      this.loadMeetings();
    }
  }

  onSearchChange() {
    this.applyFiltersAndSort();
  }

  loadMeetings() {
    this.isLoading = true;
    this.meetingListCache = [];
    this.regularAndComplianceMeetingList = [];

    const userInfo = JSON.parse(localStorage.getItem('user'));
    const uniqueUserId = userInfo.UniqueUserId;

    this.dashboardMyTaskService
      .getUserIdbyUniqueUserId(uniqueUserId)
      .then((responseForCompanyIdandUserId) => {
        if (responseForCompanyIdandUserId.status) {
          this.finishLoadingEmpty();
          return;
        }
        const promise = [];
        for (
          let index = 0;
          index < responseForCompanyIdandUserId.listOfId.length;
          index++
        ) {
          promise.push(
            this.meetingMasterService.getMeetingList(
              responseForCompanyIdandUserId.listOfId[index].CompanyId
            )
          );
        }
        if (!promise.length) {
          this.getRegularMeetingsOnly();
          return;
        }
        forkJoin(promise).subscribe(
          (responseforMeetings) => {
            const errorObject = _.find(responseforMeetings, (element) => {
              return _.get(element, 'status') == 1;
            });
            if (!_.isUndefined(errorObject)) {
              this.finishLoadingEmpty();
              return;
            }
            const tempArray = [];
            let meetingList = _.map(responseforMeetings, (element) => {
              if (!_.isUndefined(_.get(element, 'MeetingList'))) {
                return _.concat(tempArray, _.get(element, 'MeetingList'));
              }
              return _.concat(tempArray, element);
            });
            meetingList = _.flattenDeep(meetingList);

            if (!_.size(meetingList)) {
              this.getRegularMeetingsOnly();
              return;
            }

            const userSpecificMeetingList: any[] = _.filter(
              meetingList,
              (meetingObject) =>
                this.meetingVisibleForUser(
                  meetingObject,
                  responseForCompanyIdandUserId
                )
            );

            const sorted = _.sortBy(
              userSpecificMeetingList,
              (data: any) => new Date(data.MeetingDate)
            );
            this.regularAndComplianceMeetingList =
              this.regularAndComplianceMeetingList.concat(sorted);
            this.meetingListCache = this.meetingListCache.concat(sorted);
            this.getRegularMeetingsOnly();
          },
          () => this.finishLoadingEmpty()
        );
      })
      .catch(() => this.finishLoadingEmpty());
  }

  private meetingVisibleForUser(
    meetingObject: any,
    responseForCompanyIdandUserId: any
  ): boolean {
    if (_.size(_.get(meetingObject, 'Directors'))) {
      const directorArray = _.find(
        _.get(meetingObject, 'Directors'),
        (directorObject) => {
          if (_.get(directorObject, 'UserGovevaId') != undefined) {
            const assignedUser = _.find(
              responseForCompanyIdandUserId.listOfId,
              (element) =>
                element._id == _.get(directorObject, 'UserGovevaId')
            );
            if (!_.isUndefined(assignedUser)) {
              return directorObject;
            }
          }
        }
      );
      if (_.size(directorArray)) {
        return true;
      }
    }
    if (_.size(_.get(meetingObject, 'Members'))) {
      const memberArray = _.find(
        _.get(meetingObject, 'Members'),
        (memberObject) => {
          const assignedUser = _.find(
            responseForCompanyIdandUserId.listOfId,
            (element) => element._id == _.get(memberObject, 'UserGovevaId')
          );
          if (!_.isUndefined(assignedUser)) {
            return memberObject;
          }
        }
      );
      if (_.size(memberArray)) {
        return true;
      }
    }
    if (_.size(_.get(meetingObject, 'Invitees'))) {
      const inviteesArray = _.find(
        _.get(meetingObject, 'Invitees'),
        (inviteesObject) => {
          const assignedUser = _.find(
            responseForCompanyIdandUserId.listOfId,
            (element) => element._id == _.get(inviteesObject, 'UserGovevaId')
          );
          if (!_.isUndefined(assignedUser)) {
            return inviteesObject;
          }
        }
      );
      if (_.size(inviteesArray)) {
        return true;
      }
    }
    if (_.size(_.get(meetingObject, 'meetingType'))) {
      const meetingType = _.get(meetingObject, 'meetingType');
      if (!_.isUndefined(meetingType) && meetingType == 'REGULAR_MEETING') {
        return true;
      }
    }
    return false;
  }

  private getRegularMeetingsOnly() {
    this.companyMasterService.getGEMUrl().then((responseCompany) => {
      if (responseCompany.status != 0) {
        this.toAssignMeetingStatus();
        this.applyFiltersAndSort();
        return;
      }
      const companyDetails = responseCompany.companyData;
      if (!_.size(companyDetails)) {
        this.toAssignMeetingStatus();
        this.applyFiltersAndSort();
        return;
      }
      const gemURL = companyDetails[0].GEMAccessURL
        ? companyDetails[0].GEMAccessURL
        : '';
      this.meetingMasterService
        .getRegularMeetingList(gemURL)
        .then((response) => {
          if (_.size(response)) {
            this.regularAndComplianceMeetingList =
              this.regularAndComplianceMeetingList.concat(
                response.regularMeetingList
              );
            this.meetingListCache = this.meetingListCache.concat(
              response.regularMeetingList
            );
          }
          this.toAssignMeetingStatus();
          this.applyFiltersAndSort();
        })
        .catch(() => {
          this.toAssignMeetingStatus();
          this.applyFiltersAndSort();
        });
    }).catch(() => {
      this.toAssignMeetingStatus();
      this.applyFiltersAndSort();
    });
  }

  private toAssignMeetingStatus() {
    const self = this;
    _.forEach(this.regularAndComplianceMeetingList, (o) => {
      let meetingdate = new Date(o.MeetingDate).setHours(0, 0, 0, 0);
      if (o.meetingType == 'REGULAR_MEETING') {
        meetingdate = new Date(o.meetingDate).setHours(0, 0, 0, 0);
      }
      if (meetingdate == self.todayDate) {
        _.assign(o, { meetingStatus: 'Today' });
      } else if (meetingdate > self.todayDate) {
        _.assign(o, { meetingStatus: 'Future' });
      } else if (meetingdate < self.todayDate) {
        _.assign(o, { meetingStatus: 'Past' });
      }
    });
  }

  private finishLoadingEmpty() {
    this.isLoading = false;
    this.isEmpty = true;
    this.displayedMeetings = [];
  }

  applyFiltersAndSort() {
    const q = (this.searchText || '').trim().toLowerCase();
    let pool = [...this.meetingListCache];

    if (q) {
      pool = pool.filter((m) =>
        this.searchableText(m).toLowerCase().includes(q)
      );
      pool.sort(
        (a, b) => this.meetingStartMs(a) - this.meetingStartMs(b)
      );
    } else {
      const todayDate = new Date().setHours(0, 0, 0, 0);
      pool = pool.filter((o) => {
        const meetingdate = new Date(o.MeetingDate).setHours(0, 0, 0, 0);
        const RgmeetingDate = o.meetingDate
          ? new Date(o.meetingDate).setHours(0, 0, 0, 0)
          : meetingdate;
        if (RgmeetingDate == todayDate) {
          return true;
        }
        return meetingdate == todayDate;
      });
      pool = this.sortTodayByProximity(pool);
    }

    this.displayedMeetings = pool;
    this.isEmpty = !_.size(this.displayedMeetings);
    this.isLoading = false;
  }

  private searchableText(m: any): string {
    const typeName =
      m.MeetType == 'Meeting'
        ? m.MeetingTypeName || ''
        : 'CR-' + (m.MeetingTypeName || '');
    const title = m.meetingType
      ? m.meetingName || ''
      : m.MeetingTypeID && m.MeetingTypeID.MeetingType
      ? m.MeetingTypeID.MeetingType
      : '';
    return `${typeName} ${title}`.trim();
  }

  private meetingStartMs(meeting: any): number {
    try {
      const datePart =
        meeting.meetingType == 'REGULAR_MEETING'
          ? meeting.meetingDate || meeting.MeetingDate
          : meeting.MeetingDate;
      const timePart = meeting.meetingType
        ? meeting.meetingTime
        : meeting.MeetingTime;
      const base = new Date(datePart);
      if (isNaN(base.getTime())) {
        return 0;
      }
      if (!timePart) {
        return base.getTime();
      }
      const combined = Date.parse(
        `${base.toLocaleDateString()} ${timePart}`
      );
      return isNaN(combined) ? base.getTime() : combined;
    } catch {
      return 0;
    }
  }

  /** Today's meetings: upcoming from "now" soonest first, then earlier-today most recent first */
  private sortTodayByProximity(meetings: any[]): any[] {
    const now = Date.now();
    const withMs = meetings.map((m) => ({ m, t: this.meetingStartMs(m) }));
    const upcoming = withMs
      .filter((x) => x.t >= now)
      .sort((a, b) => a.t - b.t);
    const past = withMs
      .filter((x) => x.t < now)
      .sort((a, b) => b.t - a.t);
    return [...upcoming, ...past].map((x) => x.m);
  }

  meetingTypeLabel(m: any): string {
    if (m.MeetType == 'Meeting') {
      return m.MeetingTypeName || '';
    }
    return 'CR-' + (m.MeetingTypeName || '');
  }

  meetingTitle(m: any): string {
    if (m.meetingType) {
      return m.meetingName || '';
    }
    return m.MeetingTypeID && m.MeetingTypeID.MeetingType
      ? m.MeetingTypeID.MeetingType
      : '';
  }

  meetingDateDisplay(m: any): string {
    const d = m.meetingType ? m.meetingDate : m.MeetingDate;
    if (!d) {
      return '';
    }
    return new Date(d).toLocaleDateString(undefined, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  meetingTimeDisplay(m: any): string {
    return m.meetingType ? m.meetingTime : m.MeetingTime;
  }

  openMeetingModal(meetingDetails: any) {
    const self = this;
    const modalRef = this.modalService.open(MeetingdetailsComponent, {
      windowClass: 'modal-xlC',
    });
    modalRef.componentInstance.meetingObject = meetingDetails;
    modalRef.result
      .then(
        (response) => {
          const joinInPerson = localStorage.getItem('joinInPerson');
          if (joinInPerson != 'yes') {
            self.router.navigate(['webex', response]);
          } else {
            self.router.navigate(['/attending-inperson', response]);
          }
        },
        () => {}
      )
      .catch(() => {});
  }

  showRegularEdit(meeting: any): boolean {
    return (
      meeting.meetingType == 'REGULAR_MEETING' &&
      environment.Service.RegularMeeting
    );
  }

  loadRegularMeetingByID(meetingId: string) {
    const gemURL = environment.GEMURL;
    this.meetingMasterService
      .getRegularMeetingById(meetingId, gemURL)
      .then((response) => {
        if (_.size(response)) {
          const modalRef = this.modalService.open(RegularMeetingModalComponent);
          modalRef.componentInstance.meetingObject = response;
          modalRef.result
            .then(() => this.loadMeetings())
            .catch(() => {});
        }
      });
  }
}
